<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.client_no}}</td>
            <td>{{item.client_phone}}</td>
            <td>{{item.client_name}}</td>
            <td>{{item.client_email}}</td>
            <td>{{item.client_address}}</td>
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        search: '',
        headers: [
          // {
          //   text: 'Client No.',
          //   align: 'start fixed',
          //   value: 'client_no',
          // },
          { text: 'Client No.', value: 'client_no' },
          { text: 'Phone', value: 'client_phone' },
          { text: 'Name', value: 'client_name' },
          { text: 'Email', value: 'client_email' },
          { text: 'Address', value: 'client_address' },
        ],
        table: [],
      }
    },
    async created() {
      
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 
      
      // if (await this.$store.getters["bizdev_client/list"].length!=0) {
         await this.$store.dispatch("workshop_client_master/list")
      // }
      this.table = await this.$store.getters["workshop_client_master/list"]
      this.loadTable= false
    },

    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
    this.$parent.$parent.modalCloseList(item)
      },

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>